export default "__VITE_ASSET__CMdQZ3as__"